import { createAsyncThunk } from "@reduxjs/toolkit";

import { promiseFetchDataAuth } from 'crk-front-lib';

const APIPATH = '/api/v2';
// const DELAY_TIME = 1250;

export const queryWorkOrder = createAsyncThunk('orders/fetchWork', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-orders`;
  let _qry = '';

  if(cond.filter && cond.filter !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `filter=` + encodeURIComponent(cond.filter);
  }

  if(cond.status && cond.status !== '') {
    _qry += ( _qry === '' ? '' : '&' ) + `status=${cond.status}`;
  }

  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryContactList = createAsyncThunk('order/fetchContact', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-orders/distinct/contact_name`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryProductList = createAsyncThunk('order/fetchProduct', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-orders/distinct/product_name`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryProductUnitList = createAsyncThunk('order/fetchProductUnit', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-orders/distinct/order_unit`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const querySpecList = createAsyncThunk('order/fetchSpec', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-specs/distinct/spec_detail`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const querySpecUnitList = createAsyncThunk('order/fetchSpecUnit', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-specs/distinct/spec_unit`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryMaterialList = createAsyncThunk('order/fetchMaterial', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-boms/distinct/mat_name`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryMaterialUnitList = createAsyncThunk('order/fetchMaterialUnit', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-boms/distinct/mat_unit`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryProcessList = createAsyncThunk('order/fetchProcess', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-process/distinct/process_name`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const queryProcessUnitList = createAsyncThunk('order/fetchProcessUnit', async (cond, thunkAPI) => {
  const url = `${APIPATH}/work-process/distinct/process_unit`;
  let _qry = '';
  
  const result = await promiseFetchDataAuth(url + (_qry === '' ? '' : `?${_qry}`));

  return result;
})

export const changeStatus = createAsyncThunk('order/changeStatus', async (value, thunkAPI) => {
  // console.info(value);
  const url = `${APIPATH}/work-orders/${value._id}`;

  const result = await promiseFetchDataAuth(url, 'PATCH', value);

  return result;
})